import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import FileLoader from '../../../common/components/fileUpload';

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.handleFileUpload = this.handleFileUpload.bind(this);
  }

  handleFileUpload(event) {
    const {agency, dealer} = this.props;
    const files = event.target.files;
    
    if (files.length) {
      const data = new FormData();
      data.append('orders', files[0]);
      data.append('agency', agency);
      data.append('dealer', dealer);

      this.props.checkDealerStockOrder(data);
    }
  }

  render() {
    const {verified, verifying} = this.props;

    if (verified) {
      return null;
    }

    if (verifying) {
      return (<Button primary disabled loading />);
    }

    return (
      <FileLoader icon
        text='CARGAR PEDIDO'
        supportedFiles='text/plain'
        changeActions={this.handleFileUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const {verifying, verified} = state.dealerStockOrders;

  return {
    verifying,
    verified,
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
  };
};

const {checkDealerStockOrder} = Actions;

export default connect(mapStateToProps, {checkDealerStockOrder})(FileUpload);
